import { nextFrame } from "../../../library-js/animation/nextFrame";
import { ScrollLock } from "../../../library-js/dom-actions/ScrollLock";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { OnClick } from "../../../library-js/dom-tools/EventListeners";
import { HTMLEditor } from "../../../library-js/dom-tools/HTMLEditor";
import { RandomUIDGenerator } from "../../../library-js/random/RandomUIDGenerator";
import { TemplatesList } from "../../templates/TemplatesList";
import { Rokojori } from "../Rokojori";
import { OverlayOptions } from "./OverlayOptions";

export class Overlay
{
  static _overlayContainer:HTMLElement;
  static readonly content = new ElementType( TemplatesList.OVERLAY_CONTENT );
  static readonly visible = new ElementAttribute( "visible" );
  static readonly closer = new ElementType( "overlay-closer" );

  private static _ensureContainer()
  {
    if ( Overlay._overlayContainer )
    {
      return;
    }

    let rj = Rokojori.$;
   
    let overlayContainer = rj.templatesManager.createTemplate( TemplatesList.OVERLAY_CONTAINER, document );
    document.body.appendChild( overlayContainer );   

    rj.templatesManager.processElement( overlayContainer );

    Overlay._overlayContainer = document.querySelector( TemplatesList.OVERLAY_CONTAINER )
  }

 

  static async show( content:HTMLElement, options:OverlayOptions = null )
  {
    let id = RandomUIDGenerator.createUID();
    Overlay._activeID = id;

    options = options || OverlayOptions.getDefault();
    Overlay._ensureContainer();

    let overlayContent = Overlay.content.query( Overlay._overlayContainer );
    overlayContent.innerHTML = "";
    overlayContent.appendChild( content );

    let closer = Overlay.closer.query( Overlay._overlayContainer ) as HTMLElement;

    closer.style.display = options.isClosable ? "inline-block" : "none";

    if ( options.isClosable )
    {
      let onClose = ()=>
      { 
        options.onClose.dispatch( null );
        Overlay.hide();
        OnClick.remove( closer, onClose );
      }

      OnClick.add( closer, onClose );
    }

    

    for ( let i =0 ; i < 2; i++)
    { 
      await nextFrame();
    }
    
    Overlay.visible.to( Overlay._overlayContainer, true + "" );

    
    ScrollLock.enable();
  }

  private static _activeID:string = null;
  
  static hide()
  {
    let id = RandomUIDGenerator.createUID();
    Overlay._activeID = id;

    Overlay.visible.to( Overlay._overlayContainer, false +"" );

    ScrollLock.disable();

    setTimeout(
      ()=>
      {
        if ( Overlay._activeID === id )
        {
          let overlayContent = Overlay.content.query( Overlay._overlayContainer );
          overlayContent.innerHTML = "";
        }
        
      },

      500
    )
  }
}